<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
          }"
                    ref="ruleForm"
                    :rules="rules"
      >
        <a-form-model-item prop="name"
                           label="项目名称">
          <a-input placeholder="请输入项目名称" v-model="model.name" />
        </a-form-model-item>
        <a-form-model-item
          prop="code"
          label="项目CODE">
          <a-input placeholder="请输入项目code" v-model="model.code" />
        </a-form-model-item>
        <a-form-model-item
          prop="planEndDate"
          label="预计结束时间">
          <a-date-picker value-format='YYYY-MM-DD' v-model="model.planEndDate" />
        </a-form-model-item>
        <a-form-model-item
          label="项目简介">
          <a-textarea :rows="3" placeholder="请输入项目简介" v-model="model.intro" />
        </a-form-model-item>
        <a-form-model-item
          prop="contact"
          label="项目联系人">
          <a-input placeholder="请输入项目联系人" v-model="model.contactName" style="width: 80%" readOnly /> <a-button icon="search" style="margin-left: 10px" @click="selectUserView('1')"></a-button>
        </a-form-model-item>
        <a-form-model-item
          label="项目联系电话">
          <a-input placeholder="请输入项目联系电话" v-model="model.contactPhone" />
        </a-form-model-item>

        <a-form-model-item
          prop="researchType"
          label="研究类型">
          <a-input placeholder="请输入研究类型" v-model="model.researchType" />
        </a-form-model-item>
        <a-form-model-item
          prop="designScheme"
          label="设计方案">
          <a-input placeholder="请输入设计方案" v-model="model.designScheme"  />
        </a-form-model-item>
        <a-form-model-item
          prop="designModal"
          label="设计模式">
          <a-input placeholder="请输入设计模式" v-model="model.designModal" />
        </a-form-model-item>
        <a-form-model-item
          prop="sampleCount"
          label="总样本量">
          <a-input-number placeholder="请输入总样本量" v-model="model.sampleCount" :min="0" :precision="0" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item
          prop="projectCreateUserId"
          label="项目申办人">
          <a-input placeholder="请输入项目申办人" v-model="model.projectCreateUserName"  style="width: 80%" readOnly /> <a-button icon="search" style="margin-left: 10px" @click="selectUserView('2')"></a-button>
        </a-form-model-item>
        <a-form-model-item
          prop="specialCode"
          extra="重置、终止、结束时需要输入验证"
          label="特殊码">
          <a-input placeholder="请输入特殊码" v-model="model.specialCode"  />
        </a-form-model-item>
        <a-form-model-item
          prop="centerIds"
          label="中心">
          <a-select v-model="model.centerIdList" mode="multiple" @change="centerChange">
            <a-select-option :value="item.id" v-for="item in centerList">{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
    <Select-User-Modal ref="selectUserModal" :single="'1'" @selectFinished="selectUserOK"></Select-User-Modal>
  </a-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  import SelectUserModal from '@/views/system/modules/SelectUserModal'

  export default {
    name: "ProjectModal",
    components: { SelectUserModal  },
    data () {
      return {
        centerList:[],
        title:"操作",
        visible: false,
        model: {},
        rules:{
          name:[baseRules.required],
          code:[baseRules.required],
          planEndDate:[baseRules.requiredChange],
          contact:[{ required: true, message: '请选择项目联系人', trigger: 'change' }],
          researchType:[baseRules.required],
          sampleCount:[baseRules.required],
          projectCreateUserId:[{ required: true, message: '请选择项目申办人', trigger: 'change' }],
          specialCode:[baseRules.required],
          centerIds:[baseRules.requiredChange],
        },
        confirmLoading: false,
        validatorRules:{
        },
        url: {
          add: "/management/project/add",
          edit: "/management/project/edit",
        },
        selectUserType:'',
      }
    },
    created () {

    },
    methods: {
      selectUserOK(keys,records){
        const record = records[0]
        if(this.selectUserType==='1'){
          // 项目联系人
          this.$set(this.model,'contactName',record.realname)
          this.$set(this.model,'contact',record.id)
          this.$set(this.model,'contactPhone',record.phone || record.telephone)
        }else{
          // 项目申办人
          this.$set(this.model,'projectCreateUserId',record.id)
          this.$set(this.model,'projectCreateUserName',record.realname)
        }
      },
      selectUserView(type){
        this.$refs.selectUserModal.visible = true;
        this.selectUserType=type
      },
      centerChange(keys){
        let ids=''
        keys.forEach(item=>{
          ids += item+','
        })
        if(ids.length>0){
          ids = ids.substring(0,ids.length-1)
        }
        this.$set(this.model,'centerIds',ids)
        console.log(this.model)
      },
      add () {
        this.edit({});
      },
      edit (record) {
        let centerIdList = []
        if(record.centerIds){
          centerIdList = record.centerIds.split(',')
        }
        this.model = Object.assign({centerIdList:centerIdList}, record);
        getAction('/management/center/listAll',{status:'1'}).then(res=>{
          if(res.success){
            this.visible = true;
            this.centerList = res.result
          }else{
            this.$message.error(res.message)
          }
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = this.model;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style lang="less" scoped>

</style>